import { render, staticRenderFns } from "./ASRComposition.vue?vue&type=template&id=5c931e1d&"
import script from "./ASRComposition.vue?vue&type=script&lang=js&"
export * from "./ASRComposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports